import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import PollsGroupClassDetails from '../PollsGroupClassDetails/PollsGroupClassDetails';
import DefaultReportsPage from '../DefaultReportPage/DefaultReportPage';
import GroupClassCard from '../GroupClassCard/GroupClassCard';
import { getPollsGroupClassData, getPollsResultData } from '../../service/polls.service';
import { STORE_NAMES } from '../../constants/store.constants';
import { NO_MORE_RECORDS_MESSAGE, FILTER_REPORT_DATE_FORMAT, REPORT_TYPE } from '../../constants/report.constant';
import { ACTION_TYPES } from '../../constants/store.constants';
import { POLLS_DATE_FILTER_TITLE } from '../../constants/report.constant';

const Polls = () => {
  const { provider: { nuid: epicuserId = null } = {}, appointmentRegion = '' } = useSelector(state => state?.[STORE_NAMES.APPOINTMENT_DETAILS]);
  const { startDate, endDate } = useSelector(state => state?.[STORE_NAMES.POLLS]);
  const [pollsGroupClassList, setPollsGroupClassList] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [pollsList, setPollsList] = useState(null);
  const [noMoreRecordsMessage, setNoMoreRecordsMessage] = useState(null);

  const handleGroupClassCardClick = (item, index) => {
    setPollsList(null);
    setSelectedCardIndex(index);
    fetchPollsData(item);
  };

  const fetchPollsData = async ({ zoomMeetingUuid }) => {
    try {
      const pollsData = await getPollsResultData(zoomMeetingUuid);
      if (pollsData?.error) {
        setPollsList(null);
        return;
      }
      setPollsList(pollsData);
    } catch (err) {
      setPollsList(null);
    }
  };

  const fetchPollsGroupClassList = async ({ startDate, endDate }) => {
    try {
      const startDateFormatted = dayjs(startDate).format(FILTER_REPORT_DATE_FORMAT);
      const endDateFormatted = dayjs(endDate).format(FILTER_REPORT_DATE_FORMAT);
      const payload = {
        nuid: epicuserId,
        startDate: startDateFormatted,
        endDate: endDateFormatted,
        region: appointmentRegion,
        groupClassName: ''
      };
      const { videoVisits } = await getPollsGroupClassData(payload);
      if (videoVisits.length > 0) {
        setPollsGroupClassList(videoVisits);
        return;
      }
      setNoMoreRecordsMessage(NO_MORE_RECORDS_MESSAGE.noResponse);
    } catch (err) {
      setNoMoreRecordsMessage(NO_MORE_RECORDS_MESSAGE.noResponse);
    }
  };

  const renderPollsGroupClassItems = () => {
    if (Array.isArray(pollsGroupClassList) && pollsGroupClassList.length > 0) {
      const pollsGroupCLassItemList = pollsGroupClassList.map((groupClassItem, itemIndex) => {
        const classListItemIndex = `vve-class-item-${itemIndex}`;
        return (
          <div
            role="button"
            tabIndex="0"
            key={classListItemIndex}
            onClick={() => handleGroupClassCardClick(groupClassItem, itemIndex)}
            className={`${selectedCardIndex === itemIndex ? 'vve-active-card' : ''}`}
          >
            <GroupClassCard key={groupClassItem.visitTypeName} {...groupClassItem} reportType={REPORT_TYPE.POLL} />
          </div>
        );
      });
      return (
        <div className="vve-polls-card-list">
          {pollsGroupCLassItemList}
          <div className="vve-polls-class-message">{NO_MORE_RECORDS_MESSAGE.endOfRecords}</div>
        </div>
      );
    }
    return null;
  };

  useEffect(() => {
    setSelectedCardIndex(null);
    setPollsGroupClassList(null);
    setPollsList(null);
    setNoMoreRecordsMessage(null);
    if (startDate && endDate) {
      fetchPollsGroupClassList({ startDate, endDate });
    }
  }, [startDate, endDate]);

  return (
    <div className="container-fluid vve-polls-container">
      <div className="row">
        <div className="col-md-4">
          <DefaultReportsPage
            startDate={startDate}
            endDate={endDate}
            actionType={ACTION_TYPES.SET_POLLS_START_END_DATE}
            modalTitle={POLLS_DATE_FILTER_TITLE}
          />
          {renderPollsGroupClassItems()}
          {noMoreRecordsMessage && <div className="vve-polls-class-message">{noMoreRecordsMessage}</div>}
        </div>
        <div className="col-md-8">{pollsList && <PollsGroupClassDetails {...pollsList} />}</div>
      </div>
    </div>
  );
};
export default Polls;
